<div>
    <div class="d-flex align-items-center" mat-dialog-title>
        <div class="spacer title">Inhuurbedrijven</div>
        <div>
            <button mat-dialog-close mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
        </div>
    </div>
</div>
<div class="dialog-content">
    <div class="col-24">
        <table class="table table-hover" cdkDropList>
            <tr>
                <th>Naam</th>
                <th>Telefoonnummer</th>
                <th>E-mailadres</th>
            </tr>
            @for (entity of hiringList; track entity) {
                <tr class="curpoint" (click)="open(entity)">
                    <td>
                        {{ entity.name }}
                    </td>
                    <td>
                        {{ entity.phone }}
                    </td>
                    <td>
                        {{ entity.email }}
                    </td>
                </tr>
            }
        </table>
    </div>
</div>
